import { render, staticRenderFns } from "./FrameOverlay.vue?vue&type=template&id=130a9787&"
import script from "./FrameOverlay.vue?vue&type=script&lang=js&"
export * from "./FrameOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports